var storefrontApp = angular.module('storefrontApp');
storefrontApp.service('helpPageService', ['$http', function ($http) {
    return {
       
        
        getHelpPageContent: function () {
            return $http.get('helppagecontent');
        },
        
       
    }
}]);
